import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../../yeffect/StateProvider';
import {API, BROKER_EMAIL, EMAIL_API} from "../../../../config";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {connect} from "react-redux";

import {Button, Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Paper} from "@material-ui/core";
import TextInput from "../../../../yeffect/formBuilder/components/TextInput";
import InputRow from "../../../../yeffect/formBuilder/components/InputRow";
import RadioInput from "../../../../yeffect/formBuilder/components/RadioInput";
import CheckBoxInput from "../../../../yeffect/formBuilder/components/CheckboxInput";
import SelectInput from "../../../../yeffect/formBuilder/components/SelectInput";
import CFIGroup from "../../../../yeffect/formBuilder/components/CFIGroupSelect";
import CFILevel1 from "../../../../yeffect/formBuilder/components/CFILevel1Select";
import CFILevel2 from "../../../../yeffect/formBuilder/components/CFILevel2Select";
import CFILevel3 from "../../../../yeffect/formBuilder/components/CFILevel3Select";
import CFILevel4 from "../../../../yeffect/formBuilder/components/CFILevel4Select";
import CFIValue from "../../../../yeffect/formBuilder/components/cfiValue";

import {formBuilder, formBuilder2, formBuilder3, formBuilder4} from "../isinFormFields";
import {formBuilderdebt, formBuilder2debt} from "../debtFormFields";
import Document from "./UploadDocument";
import Util from "../../../../yeffect/utils";
import CountrySelect from "../../../../yeffect/formBuilder/components/CountrySelect";

import _ from "lodash";
import ConfirmationEmail from "./comms_confirmation";
import BillingEmail from "./comms_billing";
import IssuanceEmail from "./comms_issuance";
const axios = require('axios');

const isin_records = API.service('isin-records');
const uploadedFiles = API.service('uploaded-files');

const permanentFields = [
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'ID', fieldName:'uniqueIdent'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'ISIN', fieldName:'isin'},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-full',fieldLabel:'Status', fieldName:'status',
        possibleValues:[{value:'','label':'-'}, {value:'Invoiced','label':'Invoiced'}, {value:'Incoming','label':'Incoming'}, {value:'Paid','label':'Paid'}, {value:'In Review','label':'In Review'}, {value:'Issued','label':'Issued'}, {value:'PreIssued','label':'PreAssigned'}, {value:'Cancelled','label':'Cancelled'}]},
    {type:'InputRow',width:'w-full'},
        {type:'selectinput',width:'w-full',fieldLabel:'ANNA Status', fieldName:'anna_status',
        possibleValues:[{value:'','label':'-'}, {value:'P','label':'PreAssigned (P)'}, {value:'New','label':'New (N)'}, {value:'U','label':'Updated (U)'}, {value:'D','label':'Deleted (D)'}, {value:'E','label':'Excluded from Upload (E)'}]},
    {type:'InputRow',width:'w-full'},
    {type:'cfivalue',width:'w-full',fieldLabel:'CFI', fieldName:'cfi', categoryFieldName:'cfi_category', groupFieldName:'cfi_group', lvl1FieldName:'cfi_level1', lvl2FieldName:'cfi_level2', lvl3FieldName:'cfi_level3', lvl4FieldName:'cfi_level4'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'FISN', fieldName:'fisn'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'LEI', fieldName:'lei'},
]

const financialFields = [
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-full',fieldLabel:'CFI Code Generation'},
    {type:'InputRow',width:'w-full'},
    {type:'cfivalue',width:'w-full',fieldLabel:'CFI Value', fieldName:'cfi', categoryFieldName:'cfi_category', groupFieldName:'cfi_group', lvl1FieldName:'cfi_level1', lvl2FieldName:'cfi_level2', lvl3FieldName:'cfi_level3', lvl4FieldName:'cfi_level4'},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-full',fieldLabel:'CFI Category', fieldName:'cfi_category',
        possibleValues:[
            {value:'E','label':'E: Equities'},
            {value:'D','label':'D: Debt'},
            {value:'C','label':'C: Collective Investment Vehicles'},
            {value:'R','label':'R: Entitlements (Rights)'},
            {value:'O','label':'O: Listed Options'},
            {value:'F','label':'F: Futures'},
            {value:'T','label':'T: Referential Instruments'},
            {value:'M','label':'M: Other(Miscellaneous)'},
        ]},
    {type:'cfigroup', width:'w-full',fieldLabel:'CFI Group', fieldName:'cfi_group', categoryFieldName:'cfi_category'},
    {type:'cfilevel1', width:'w-full',fieldLabel:'CFI 1st Attribute', fieldName:'cfi_level1', categoryFieldName:'cfi_category', groupFieldName:'cfi_group'},
    {type:'cfilevel2', width:'w-full',fieldLabel:'CFI 2nd Attribute', fieldName:'cfi_level2', categoryFieldName:'cfi_category', groupFieldName:'cfi_group', lvl1FieldName:'cfi_level1'},
    {type:'cfilevel3', width:'w-full',fieldLabel:'CFI 3rd Attribute', fieldName:'cfi_level3', categoryFieldName:'cfi_category', groupFieldName:'cfi_group', lvl1FieldName:'cfi_level1', lvl2FieldName:'cfi_level2'},
    {type:'cfilevel4', width:'w-full',fieldLabel:'CFI 4th Attribute', fieldName:'cfi_level4', categoryFieldName:'cfi_category', groupFieldName:'cfi_group', lvl1FieldName:'cfi_level1', lvl2FieldName:'cfi_level2', lvl3FieldName:'cfi_level3'},

]

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    detail:{
        height:'100%',
        overflow:'auto'
    },
    detailContent:{
        margin:'8px 0',
        paddingTop:'10px'
    },
    tabs:{
        display:'inline-block',
        width:'100%',
        borderBottom:'2px solid #6a94ff',
        marginLeft:0,
        paddingLeft:0,

        '& li':{
            display:'inline-block',

            '& button':{
                margin:'1px',
                padding:'6px 12px',
                backgroundColor:'#383c42',
                color:'white'
            },
            '& button:hover':{
                backgroundColor:'#6a94ff',
            },
            '& button.active':{
                backgroundColor:'#6a94ff',
            }
        }
    },
    flex: {
        flex: 1,
    },

});

class OpenIsin extends Component {
    state={
        activeTab:'issuer',
        formResults: (typeof this.props.isin.uniqueIdent === 'undefined') ? {
            application_type: (typeof this.props.isin.application_type !== "undefined") ? this.props.isin.application_type : this.props.application_type,
            uniqueIdent: Util.uuid(),
        } : JSON.parse(JSON.stringify(this.props.isin)),
        debug: false,
        application_type: (typeof this.props.isin.application_type !== "undefined") ? this.props.isin.application_type : this.props.application_type,
        docIds : [],
        payments : [],
        billingSameAsRequester: false,
        errors:{},
        commsSection: 'confirmation',
        usedIsins: [],
    }

    closeDetails = () => {
        this.props.context.update({
            drawerContent:false,
            drawerWidth:null
        })
    }

    componentDidMount() {
        const app = this;

        uploadedFiles.find({query:{assoc_id:this.state.formResults['uniqueIdent'],fieldname:'isin-document'}}).then(x=> {

            let usedIsins = [];
            this.props.isins.forEach(x=>{
                usedIsins[x.id] = x.isin
            })

            uploadedFiles.find({query:{assoc_id:this.state.formResults['uniqueIdent'],fieldname:'isin-payment'}}).then(p=> {

                let usedIsins = [];
                this.props.isins.forEach(x=>{
                    usedIsins[x.id] = x.isin
                })

                app.setState({
                    permanentFields: this.buildForm(permanentFields),
                    formDefinition1: this.buildForm(this.state.application_type === "equity" ? formBuilder : formBuilderdebt),
                    formDefinition2: this.buildForm(this.state.application_type === "equity" ? formBuilder2 : formBuilder2debt),
                    formDefinition3: this.buildForm(formBuilder3),
                    formDefinition4: this.buildForm(formBuilder4),
                    financial1: this.buildForm(financialFields),
                    docIds: x.data,
                    payments: p.data,
                    usedIsins: usedIsins,
                }, () => console.log(this.state["formDefinition" + 1]));
            })
        })
    }

    fieldContent = (formRow) =>{
        if(formRow.type==='InputRow'){
            return (<InputRow>
                    {formRow.children.map((v,i)=>{
                        return this.fieldContent(v)
                    })}
                </InputRow>
            )
        };

        if(formRow.type==='textinput'){
            return (<TextInput fieldLabel={formRow.fieldLabel} width={formRow.width} onChange={this.updateFormContent} value={this.state.formResults[formRow.fieldName] } fieldName={formRow.fieldName} required={(formRow.required)} errorFields={this.state.errors} />)
        }

        if(formRow.type==='cfivalue'){
            return (<CFIValue fieldLabel={formRow.fieldLabel}
                              width={formRow.width}
                              categoryValue={this.state.formResults[formRow.categoryFieldName]}
                              groupValue={this.state.formResults[formRow.groupFieldName]}
                              lvl1Value={this.state.formResults[formRow.lvl1FieldName]}
                              lvl2Value={this.state.formResults[formRow.lvl2FieldName]}
                              lvl3Value={this.state.formResults[formRow.lvl3FieldName]}
                              lvl4Value={this.state.formResults[formRow.lvl4FieldName]}
                              />)
        }

        if(formRow.type==='radioinput'){
            return (<RadioInput fieldLabel={formRow.fieldLabel} width={formRow.width} possibleValues={formRow.possibleValues} fieldName={formRow.fieldName} onChange={this.updateFormContent} /> )
        }

        if(formRow.type==='checkinput'){
            return (<CheckBoxInput fieldLabel={formRow.fieldLabel} width={formRow.width} onChange={this.updateFormContent} fieldName={formRow.fieldName} value={this.state.formResults[formRow.fieldName]} />)
        }

        if(formRow.type==='selectinput'){
            return (<SelectInput fieldLabel={formRow.fieldLabel} width={formRow.width} possibleValues={formRow.possibleValues} value={this.state.formResults[formRow.fieldName] } onChange={this.updateFormContent} required={(formRow.required)} fieldName={formRow.fieldName} errorFields={this.state.errors} />)
        }

        if(formRow.type==='cfigroup'){
            return (<CFIGroup fieldLabel={formRow.fieldLabel} width={formRow.width} categoryValue={this.state.formResults[formRow.categoryFieldName]} value={this.state.formResults[formRow.fieldName] } onChange={this.updateFormContent} required={(formRow.required)} fieldName={formRow.fieldName} errorFields={this.state.errors} />)
        }

        if(formRow.type==='cfilevel1'){
            return (<CFILevel1 fieldLabel={formRow.fieldLabel} width={formRow.width} categoryValue={this.state.formResults[formRow.categoryFieldName]} groupValue={this.state.formResults[formRow.groupFieldName]} value={this.state.formResults[formRow.fieldName] } onChange={this.updateFormContent} required={(formRow.required)} fieldName={formRow.fieldName} errorFields={this.state.errors} />)
        }

        if(formRow.type==='cfilevel2'){
            return (<CFILevel2 fieldLabel={formRow.fieldLabel} width={formRow.width} categoryValue={this.state.formResults[formRow.categoryFieldName]} groupValue={this.state.formResults[formRow.groupFieldName]} lvl1Value={this.state.formResults[formRow.lvl1FieldName]} value={this.state.formResults[formRow.fieldName] } onChange={this.updateFormContent} required={(formRow.required)} fieldName={formRow.fieldName} errorFields={this.state.errors} />)
        }

        if(formRow.type==='cfilevel3'){
            return (<CFILevel3 fieldLabel={formRow.fieldLabel} width={formRow.width} categoryValue={this.state.formResults[formRow.categoryFieldName]} groupValue={this.state.formResults[formRow.groupFieldName]} lvl1Value={this.state.formResults[formRow.lvl1FieldName]} value={this.state.formResults[formRow.fieldName] } onChange={this.updateFormContent} required={(formRow.required)} fieldName={formRow.fieldName} errorFields={this.state.errors} />)
        }

        if(formRow.type==='cfilevel4'){
            return (<CFILevel4 fieldLabel={formRow.fieldLabel} width={formRow.width} categoryValue={this.state.formResults[formRow.categoryFieldName]} groupValue={this.state.formResults[formRow.groupFieldName]} lvl1Value={this.state.formResults[formRow.lvl1FieldName]} value={this.state.formResults[formRow.fieldName] } onChange={this.updateFormContent} required={(formRow.required)} fieldName={formRow.fieldName} errorFields={this.state.errors} />)
        }

        if(formRow.type==='countryselect'){
            return (<CountrySelect fieldLabel={formRow.fieldLabel} width={formRow.width} value={this.state.formResults[formRow.fieldName] } onChange={this.updateFormContent} required={(formRow.required)} fieldName={formRow.fieldName} errorFields={this.state.errors} />)
        }

        if(formRow.type==='sectionHeading'){
            return (<h3>{formRow.fieldLabel}</h3>)
        }
    }

    setBillingSame = () => {
        let currentResults = this.state.formResults;
        currentResults['billing_firstname'] = currentResults['requester_firstname'];
        currentResults['billing_lastname'] = currentResults['requester_lastname'];
        currentResults['billing_email'] = currentResults['requester_email'];
        currentResults['billing_phone'] = currentResults['requester_phone'];
        currentResults['billing_company'] = currentResults['requester_company'];
        currentResults['billing_street_address'] = currentResults['requester_street_address'];
        currentResults['billing_street_address_2'] = currentResults['requester_street_address_2'];
        currentResults['billing_city'] = currentResults['requester_city'];
        currentResults['billing_state'] = currentResults['requester_state'];
        currentResults['billing_postcode'] = currentResults['requester_postcode'];
        currentResults['billing_country'] = currentResults['requester_country'];
        this.setState({
            formResults:currentResults,
        })
    }

    sameAsRequestor = (event) => {
        if (event.target.checked) {
            let currentResults = this.state.formResults;
            delete currentResults['billing_firstname'];
            delete currentResults['billing_lastname'];
            delete currentResults['billing_email'];
            delete currentResults['billing_phone'];
            delete currentResults['billing_company'];
            delete currentResults['billing_street_address'];
            delete currentResults['billing_street_address_2'];
            delete currentResults['billing_city'];
            delete currentResults['billing_state'];
            delete currentResults['billing_postcode'];
            delete currentResults['billing_country'];
            this.setState({
                formResults:currentResults,
                billingSameAsRequester: true,
            })
        } else {
            this.setState({
                billingSameAsRequester: false,
            })
        }
    }

    buildForm(formDefinition){
        let rowOpen = false;
        let compiled = []
        formDefinition.forEach((v,i)=>{
            if(v.type==='InputRow'){
                if(rowOpen !== false){
                    compiled.push(formDefinition[rowOpen])
                    rowOpen = i;
                    formDefinition[i].children=[];
                } else {
                    rowOpen = i;
                    formDefinition[i].children=[];
                }
            } else {
                if(rowOpen !== false) {
                    formDefinition[rowOpen].children.push(v)
                } else {
                    compiled.push(v)
                }
            }
        })
        if(rowOpen !== false){
            compiled.push(formDefinition[rowOpen])
        }
        return compiled;
    }

    fieldValidation(method, value) {
        if(method === 'email'){
            return (Util.validateEmail(value)) ? true : "Please enter a valid email address."
        }

        if(method === 'number'){
            return (Util.validateNumber(value)) ? true : "Please only enter numbers."
        }
    }

    changeTab = (e, variable, value=null) => {
        if(value === null){
            value = e.target.id;
        }
        this.setState(_.set({ ...this.state, error: '' }, variable, value));

        /*this.setState({
        //    activeTab:e.target.id
        })*/
    }

    validateStage = () => {
        let form = [];
        let errors = {};
        if(this.state.stage === 'issuer'){
            form = (this.props.match.params.type === "equity") ? formBuilder : formBuilderdebt;
        }
        if(this.state.stage === 'issue'){
            form = (this.props.match.params.type === "equity") ? formBuilder2 : formBuilder2debt;
        }
        if(this.state.stage === 'requestor'){
            form = formBuilder3
        }
        if(this.state.stage === 'billing'){
            form = formBuilder4
        }

        if(form.length !== 0) {
            form.forEach((v, i) => {
                if (typeof v.validate !== "undefined" && (Util.isEmpty(this.state.formResults[v.fieldName]) === false) ){
                    let result = this.fieldValidation(v.validate, this.state.formResults[v.fieldName])
                    if(result !== true){
                        errors[v.fieldName] = result;
                    }
                }

                if (v.required === true && Util.isEmpty(this.state.formResults[v.fieldName])) {
                    errors[v.fieldName] = "Please enter a value for " + v.fieldLabel;
                }

            })
        }

        this.setState({
            errors:errors
        })

        return (Object.keys(errors).length === 0)
    };

    updateInbound = (doc_id) => {
        console.log(doc_id)
        let docs = this.state.docIds;
        docs.push(doc_id);
        this.setState({
            docIds:docs,
        })
    }

    prepareAdminEmail = () => {
        let content = "<h4>Issuer Information</h4>";
        content += this.buildEmail(this.state.formResults.application_type === "equity" ? formBuilder : formBuilderdebt);
        content += "<h4>Issue Information</h4>";
        content += this.buildEmail(this.state.formResults.application_type === "equity" ? formBuilder2 : formBuilder2debt);
        content += "<h4>Requester Information</h4>";
        content += this.buildEmail(formBuilder3);
        content += "<h4>Billing Information</h4>";
        content += this.buildEmail(formBuilder4);

        return content;
    }

    prepareBillingEmail = () => {
        let content = "<h4>Billing Information</h4>";
        content += this.buildEmail(formBuilder4);

        return content;
    }

    buildEmail(formDefinition){
        let compiled = "";
        formDefinition.forEach((v,i)=>{
            compiled += this.emailContent(v)
        })

        return compiled + "<br /><br />";
    }

    emailContent = (formRow) =>{
        if(formRow.type==='textinput'){
            return "<b>" + formRow.fieldLabel + ":</b> " + ((typeof this.state.formResults[formRow.fieldName] !== "undefined") ? this.state.formResults[formRow.fieldName] : "" )+ "<br />";
        }

        if(formRow.type==='radioinput'){
            return "<b>" + formRow.fieldLabel + ":</b> " + ((typeof this.state.formResults[formRow.fieldName] !== "undefined") ? this.state.formResults[formRow.fieldName] : "" ) + "<br />";
        }

        if(formRow.type==='checkinput'){
            return "<b>" + formRow.fieldLabel + ":</b> " + ((typeof this.state.formResults[formRow.fieldName] !== "undefined") ? this.state.formResults[formRow.fieldName] : "" ) + "<br />";
        }


        if(formRow.type==='selectinput'){
            let content = "<b>" + formRow.fieldLabel + ":</b> ";
            formRow.possibleValues.forEach(v=>{
                if (v.value === this.state.formResults[formRow.fieldName]){
                    content = content + v.label;
                }
            });

            return content + "<br />";
        }

        return "";
    }

    submitIsin = (successCallback) => {
        if(this.state.billingSameAsRequester){
            this.setBillingSame();
        }

        if(typeof this.state.formResults.id === 'undefined') {
            isin_records.create(this.state.formResults).then(r => {
                this.setState({
                    alertContent: 'Record Created',
                    alertType: 'success'
                })
                successCallback();
            }).catch(e => {
                console.log(e);
                this.setState({
                    alertContent: 'Error Found',
                    alertType: 'error'
                })
            })
        } else {
            isin_records.update(this.state.formResults.id, this.state.formResults).then(r => {
                this.setState({
                    alertContent: 'Record Saved',
                    alertType: 'success'
                })
                successCallback();
            }).catch(e => {
                console.log(e);
                this.setState({
                    alertContent: 'Error Found',
                    alertType: 'error'
                })
            })
        }
    }

    updateFormContent = (event) =>{
        let currentForm = this.state.formResults;
        currentForm[event.target.name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({formResults: currentForm });
    }

    getISIN = (offset) => {

        let prefix = (typeof this.state.issuer_country !== 'undefined') ? this.state.issuer_country : 'CW';
        let number = Util.makeNumber(this.state.formResults.uniqueIdent.toString()).replace('-', '').substr(offset, 9);
        let check = Util.calcISINCheck(prefix + number.toString());
        let isin = prefix + number.toString() + check.toString();

        if(this.state.usedIsins.indexOf(isin) === -1 || this.state.usedIsins.indexOf(isin) === this.props.isin.id)
        {
            return isin;
        } else {
            return this.getISIN(offset + 1)
        }

    }

    generateISIN = () => {
        let current = this.state.formResults;
        current['isin'] = this.getISIN(0);

        this.setState({
          formResults: current,
        })
    }

    sendConfirmationEmail = () => {
        const controller = this;

        let payload = {
            transportName: 'sendgrid',
            to: controller.state.formResults['requester_email'],
            from: BROKER_EMAIL,
            subject: 'ISIN Application Submission',
            templateName: 'isin_application_receipt',
            language: 'en',
            data: {
                formContent: controller.prepareAdminEmail(),
                uniqueIdent: controller.state.formResults['uniqueIdent']
            }
        }

        axios.post(EMAIL_API + '/requests', {
                sender: 'ISIN Application',
                payload: payload
            }
        ).then(function (data) {
            console.log(data)
        }).catch(e=> {
            console.log(e)
        })
    }

    sendBillingEmail = () => {
        const controller = this;

        let payload = {
            transportName: 'sendgrid',
            to: 'administration@dcsx.cw',
            from: BROKER_EMAIL,
            subject: 'ISIN Application Submission',
            templateName: 'isin_application_receipt',
            language: 'en',
            data: {
                formContent: controller.prepareBillingEmail(),
                uniqueIdent: controller.state.formResults['uniqueIdent']
            }
        }

        axios.post(EMAIL_API + '/requests', {
                sender: 'ISIN Application',
                payload: payload
            }
        ).then(function (data) {
            console.log(data)
        }).catch(e=> {
            console.log(e)
        })
    }

    sendIssuanceEmail = () => {
        const controller = this;

        let payload = {
            transportName: 'sendgrid',
            to: this.state.formResults.requestor_email,
            from: BROKER_EMAIL,
            subject: 'ISIN Application Successful',
            templateName: 'isin_application_success',
            language: 'en',
            data: {
                formContent: controller.prepareBillingEmail(),
                uniqueIdent: controller.state.formResults['uniqueIdent']
            }
        }

        axios.post(EMAIL_API + '/requests', {
                sender: 'ISIN Application',
                payload: payload
            }
        ).then(function (data) {
            console.log(data)
        }).catch(e=> {
            console.log(e)
        })
    }

    render() {
        const {classes} = this.props;

        return (
            <div className={classes.detail + ' flex flex-col'} style={{height:'100vh'}}>
                <AppBar position="static">
                    <Toolbar>
                        <div className={classes.flex}>
                            <Typography variant="title" color="inherit">
                                {(typeof this.state.formResults.issuer_legal_description !== "undefined") &&
                                    <span style={{textTransform: 'capitalize'}}>{this.state.formResults.issuer_legal_description}</span>
                                }
                                {(typeof this.state.formResults.issuer_legal_description === "undefined") &&
                                    <span style={{textTransform: 'capitalize'}}>New {this.state.formResults.application_type}</span>
                                }
                            </Typography>
                            <Typography variant="subheading" color="inherit">
                                {(typeof this.state.formResults.isin !== "undefined") &&
                                    <span>{this.state.formResults.isin}</span>
                                }
                            </Typography>
                        </div>
                        <Button variant={'contained'} color={'secondary'} onClick={()=>this.submitIsin(this.props.closeDrawer)}>Save </Button> &nbsp;&nbsp;&nbsp;
                        <IconButton onClick={this.props.closeDrawer} color={'inherit'}><Icon>clear</Icon></IconButton>
                    </Toolbar>
                </AppBar>

                <div style={{padding:20,paddingBottom:0,paddingTop:0}}>

                    <div className={classes.detailContent}>
                        <ul className={classes.tabs}>
                            <li>
                                <button className={(this.state.activeTab === 'issuer') ? 'active' : ''}
                                        style={{textTransform: 'capitalize'}}
                                        onClick={(e)=>this.changeTab(e,'activeTab')} id={'issuer'}>{this.state.application_type} Issuer
                                </button>
                            </li>
                            <li>
                                <button className={(this.state.activeTab === 'issue') ? 'active' : ''}
                                        style={{textTransform: 'capitalize'}}
                                        onClick={(e)=>this.changeTab(e,'activeTab')} id={'issue'}>{this.state.application_type} Issue
                                </button>
                            </li>
                            <li>
                                <button className={(this.state.activeTab === 'requestor') ? 'active' : ''}
                                        onClick={(e)=>this.changeTab(e,'activeTab')} id={'requestor'}>Requestor
                                </button>
                            </li>
                            <li>
                                <button className={(this.state.activeTab === 'billing') ? 'active' : ''}
                                        onClick={(e)=>this.changeTab(e,'activeTab')} id={'billing'}>Billing Details
                                </button>
                            </li>
                            <li>
                                <button className={(this.state.activeTab === 'files') ? 'active' : ''}
                                        onClick={(e)=>this.changeTab(e,'activeTab')} id={'files'}>File Uploads
                                </button>
                            </li>
                            <li>
                                <button className={(this.state.activeTab === 'comms') ? 'active' : ''}
                                        onClick={(e)=>this.changeTab(e,'activeTab')} id={'comms'}>Communications
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={'flex-1'} style={{overflow:'auto',padding:20,paddingTop:0}}>
                    {(this.state.permanentFields) &&
                        <div className={'flex'}>
                            <div className={'flex-1'}>&nbsp;</div>
                            <div className={'flex-1'}>&nbsp;</div>
                            <div className={'flex-1'}>
                                {this.state.permanentFields.map((v, i) => {
                                    return this.fieldContent(v, this.state.formResults);
                                })}
                            </div>
                            <div className={'flex-1 py-24'}><Button variant="contained" color="secondary" onClick={this.generateISIN}>Generate ISIN</Button></div>
                        </div>
                    }
                    {(this.state.activeTab === 'issuer' && this.state.formDefinition1) &&
                        <React.Fragment>
                            {this.state["formDefinition1"].map((v, i) => {
                                return this.fieldContent(v, this.state.formResults);
                            })}

                            {this.state["financial1"].map((v, i) => {
                                return this.fieldContent(v, this.state.formResults);
                            })}
                        </React.Fragment>
                    }
                    {(this.state.activeTab === 'issue' && this.state.formDefinition2) &&
                    <React.Fragment>
                        {this.state["formDefinition2"].map((v, i) => {
                            return this.fieldContent(v, this.state.formResults);
                        })}
                    </React.Fragment>
                    }
                    {(this.state.activeTab === 'requestor' && this.state.formDefinition3) &&
                    <React.Fragment>
                        {this.state["formDefinition3"].map((v, i) => {
                            return this.fieldContent(v, this.state.formResults);
                        })}
                    </React.Fragment>
                    }
                    {(this.state.activeTab === 'billing' && this.state.formDefinition4) &&
                    <React.Fragment>
                        {this.state["formDefinition4"].map((v, i) => {
                            return this.fieldContent(v, this.state.formResults);
                        })}
                    </React.Fragment>
                    }

                    {(this.state.activeTab === 'files') &&
                    <React.Fragment>

                        <Paper style={{width:'50%', marginLeft:'25%',padding:30,textAlign:'center'}}>
                            <AppBar position="static" elevation={0} color={"default"}>
                                <Toolbar>
                                    <div className={classes.flex}>
                                        <Typography variant="title" color="inherit">
                                            Uploaded Documents:
                                        </Typography>
                                    </div>
                                    <div style={{marginTop:'14px'}}>
                                        <Document type={'isin-document'} label='Upload Document'
                                                  assoc_id={this.state.formResults.uniqueIdent}
                                                  placeholder='/bill.jpg'
                                                  request_id={this.state.formResults.uniqueIdent}
                                                  onComplete={this.updateInbound}
                                                  hideReviewStatus={true}
                                        />
                                    </div>
                                </Toolbar>
                            </AppBar>
                        <Table className={'mb-24'}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Filename</TableCell>
                                    <TableCell>Uploaded At</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(this.state.docIds.length > 0) &&
                                <React.Fragment>
                                    {this.state.docIds.map((v,i)=>{
                                        return (
                                            <TableRow>
                                                <TableCell>{v.orig_filename}</TableCell>
                                                <TableCell style={{textTransform: 'capitalize'}}>{v.createdAt}</TableCell>
                                                <TableCell><Button variant="outlined" color="primary" href={v.system_filename} target={'_blank'}>View</Button></TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </React.Fragment>
                                }
                            </TableBody>
                        </Table>

                            <AppBar position="static" elevation={0} color={"default"}>
                                <Toolbar>
                                    <div className={classes.flex}>
                                        <Typography variant="title" color="inherit">
                                            Proof of Payment:
                                        </Typography>
                                    </div>
                                    <div style={{marginTop:'14px'}}>
                                        <Document type={'isin-payment'} label='Upload Document'
                                                  assoc_id={this.state.formResults.uniqueIdent} placeholder='/bill.jpg' request_id={this.state.formResults.uniqueIdent}
                                                  onComplete={this.updateInbound} hideReviewStatus={true}/>
                                    </div>
                                </Toolbar>
                            </AppBar>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Filename</TableCell>
                                        <TableCell>Uploaded At</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(this.state.payments.length > 0) &&
                                    <React.Fragment>
                                        {this.state.payments.map((v,i)=>{
                                            return (
                                                <TableRow>
                                                    <TableCell>{v.orig_filename}</TableCell>
                                                    <TableCell style={{textTransform: 'capitalize'}}>{v.createdAt}</TableCell>
                                                    <TableCell><Button variant="outlined" color="primary" href={v.system_filename} target={'_blank'}>View</Button></TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </React.Fragment>
                                    }
                                </TableBody>
                            </Table>
                        </Paper>
                    </React.Fragment>
                    }

                    {(this.state.activeTab === 'comms') &&
                    <React.Fragment>
                        <div className={'flex-col flex h-full here'}>

                            <div className={'flex ' + classes.full}>
                                <div style={{width:'25%'}}>
                                    <Paper style={{position: 'relative', margin: 5}}>
                                        <AppBar position="static" elevation={0} color={"default"}>
                                            <Toolbar>
                                                <Typography variant="title" color="inherit" className={classes.flex}>
                                                    Communications
                                                </Typography>
                                            </Toolbar>
                                        </AppBar>

                                        <div style={{overflow: 'auto', height: '100%', padding: 5}}>
                                            <Button onClick={(e)=>this.changeTab(e,'commsSection','confirmation')}>Confirmation Email</Button><br />
                                            <Button onClick={(e)=>this.changeTab(e,'commsSection', 'billing')}>Billing Email</Button><br />
                                            <Button onClick={(e)=>this.changeTab(e,'commsSection', 'issuance')}>Issuance</Button>
                                        </div>
                                    </Paper>
                                </div>

                                <div className={'flex-1'}>
                                    {(this.state.commsSection === 'confirmation') &&
                                    <ConfirmationEmail isin={this.state.formResults} sendFunction={() => this.submitIsin(this.sendConfirmationEmail)} />
                                    }

                                    {(this.state.commsSection === 'billing') &&
                                    <BillingEmail isin={this.state.formResults} sendFunction={() => this.submitIsin(this.sendBillingEmail)} />
                                    }

                                    {(this.state.commsSection === 'issuance') &&
                                    <IssuanceEmail isin={this.state.formResults} sendFunction={() => this.submitIsin(this.sendIssuanceEmail)} />
                                    }
                                </div>
                            </div>

                        </div>
                    </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter((connect(mapStateToProps)(OpenIsin)))));



// WEBPACK FOOTER //
// ./src/main/content/isinApplications/components/openIsin.js